export default __webpack_public_path__ + "static/media/DAI-AVAX.ff5cecdf.png";